/**
 * DevExtreme (esm/__internal/core/license/trial_panel.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { isClient, registerCustomComponents, renderTrialPanel } from "./trial_panel.client";
export function showTrialPanel(buyNowUrl, licensingDocUrl, version, subscriptions, customStyles) {
  if (isClient()) {
    renderTrialPanel(buyNowUrl, licensingDocUrl, version, subscriptions, customStyles);
  }
}
export function registerTrialPanelComponents(customStyles) {
  if (isClient()) {
    registerCustomComponents(customStyles);
  }
}